module.exports = __webpack_public_path__ + "static/media/everyone-from-doctor-to-peon-can-diagnose-diabetes-The-New-Indian-Express.3aafec9e.pdf";